import yup from 'utils/yup';

const validationSchema = yup.object().shape({
  countryId: yup.string().nullable().required(),
  areaId: yup.string().nullable().required(),
  name: yup.string().nullable().required(),
  emergencyContacts: yup.array().of(
    yup.object().shape({
      email: yup.string().nullable().email(),
    }),
  ),
  commonContacts: yup.array().of(
    yup.object().shape({
      email: yup.string().nullable().email(),
    }),
  ),
  agreement: yup.bool().agreed(),
  address: yup.string().nullable().required(),
  coords: yup.string().nullable().coords(),
  facebookLink: yup.string().nullable().socialLink('facebook'),
  vimeoLink: yup.string().nullable().socialLink('vimeo'),
  instagramLink: yup.string().nullable().socialLink('instagram'),
});

export default validationSchema;
